import { useEffect } from 'react';
import { startTracking, stopTracking } from '../tracking';

function useAccessTracking() {
  useEffect(() => {
    startTracking();

    window.addEventListener('beforeunload', stopTracking);

    return () => {
      window.removeEventListener('beforeunload', stopTracking);
      stopTracking();  
    };
  }, []);
}

export default useAccessTracking;